exports = module.exports = require("../../../../mover/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".uds {\n  --uds-header-height: 60px;\n}\n\n@media (min-width: 768px) {\n  .uds {\n    --uds-header-height: 80px;\n  }\n}\n", ""]);

